/**
 * Internal menu styles.
 *
 * These styles are NOT exported publicly. Components expose props
 * like icon, label, showCheckmark instead of raw styles.
 */

import * as stylex from "@stylexjs/stylex";

import { colors, duration, easing, space } from "../../tokens.stylex";

export const styles = stylex.create({
  content: {
    display: "block",
    overflow: "hidden",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: space.sm,
    marginTop: space["2xs"],
    marginBottom: space["2xs"],
    marginLeft: space["2xs"],
    marginRight: space["2xs"],
    paddingTop: space.sm,
    paddingBottom: space.sm,
    paddingLeft: space.md,
    paddingRight: space.md,
    borderRadius: 10,
    cursor: "pointer",
    color: colors.foreground,
    backgroundColor: "transparent",
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.5,
    minHeight: 32,
    transitionProperty: "background-color, color",
    transitionDuration: duration.fast,
    transitionTimingFunction: easing.default,
    ":hover": {
      backgroundColor: colors.muted,
    },
  },
  itemActive: {
    backgroundColor: colors.accent,
    color: colors.accentForeground,
    ":hover": {
      backgroundColor: colors.accent,
    },
  },
  itemDestructive: {
    ":hover": {
      backgroundColor: colors.muted,
      color: colors.destructive,
    },
  },
  divider: {
    height: 1,
    backgroundColor: colors.borderSubtle,
    marginTop: space["2xs"],
    marginBottom: space["2xs"],
    marginLeft: space.sm,
    marginRight: space.sm,
  },
  subMenuTriggerContent: {
    display: "flex",
    alignItems: "center",
    gap: space.sm,
    marginTop: space["2xs"],
    marginBottom: space["2xs"],
    marginLeft: space["2xs"],
    marginRight: space["2xs"],
    paddingTop: space.sm,
    paddingBottom: space.sm,
    paddingLeft: space.md,
    paddingRight: space.md,
    borderRadius: 10,
    cursor: "pointer",
    color: colors.foreground,
    backgroundColor: "transparent",
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.5,
    minHeight: 32,
  },
  chevron: {
    marginLeft: "auto",
    color: colors.foregroundMuted,
    transform: "rotate(-90deg)",
  },
  checkmark: {
    marginLeft: "auto",
    color: colors.primary,
  },
  subMenuContent: {
    display: "block",
    overflow: "hidden",
  },
  subMenuContentInner: {
    display: "block",
    overflow: "hidden",
  },
  subMenu: {
    display: "block",
    width: "100%",
  },
  subMenuTrigger: {
    display: "block",
    width: "100%",
  },
});
